module.exports = __webpack_public_path__ + "media/images/icon-back-white-c56bb7cfad9d0e54313ec5e77ba3cd69.svg";